module.exports = __webpack_public_path__ + "img/jerusalem-zoom-01.059ee1ce.png";